import { SubmitAppEndAction } from "../actions/SubmitApp";
import { AppState } from "../state";
import { updateApp } from "./Common";

export function submitApp(state: AppState, action: SubmitAppEndAction): AppState {
    const { error, result } = action.payload;
    const app = result ? result.app : undefined;

    // @ts-ignore DataStreams issue
    return updateApp(state, { payload: { app, error }, type: action.type });
}
